import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useCallback, useState } from "react";

const Passwords = () => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");

  const handleClickShowPassword = useCallback(
    () => setShowPassword((show) => !show),
    []
  );

  const handleMouseDownPassword = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleMouseUpPassword = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    []
  );

  const handleOnSubmit = useCallback(async () => {
    try {
      setIsSubmitting(true);
      if (password.length > 0) {
        await axios.post(
          "https://us-central1-awesome-radi-languages.cloudfunctions.net/UpdatePasswordTeacher",
          {
            password,
          }
        );
        alert(`La nueva contraseña es: '${password}'.`);
      }
    } catch {
      alert(`No se pudo actualizar la contraseña. Intenta nuevamente.`);
    } finally {
      setIsSubmitting(false);
    }
  }, [password]);

  return (
    <div className="p-5">
      <Paper className="my-5 m-auto p-5 max-w-[500px]">
        <Typography variant="body1" className="text-center my-5">
          Ingresa la nueva contraseña para acceder a
          <br />
          <div className="flex items-center w-full justify-center">
            <Link href="/teacher" target="_blank">Teacher Dashboard</Link>
          </div>
        </Typography>
        <FormControl variant="filled" className="w-full">
          <InputLabel htmlFor="filled-adornment-password">
            Nueva contraseña
          </InputLabel>
          <FilledInput
            id="filled-adornment-password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? "hide the password" : "display the password"
                  }
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <div className="py-5 w-full">
          <LoadingButton
            onClick={handleOnSubmit}
            loading={isSubmitting}
            className="bg-[#06B1D3] w-full"
            variant="contained"
          >
            Guardar
          </LoadingButton>
        </div>
      </Paper>
    </div>
  );
};

export { Passwords };
